lhs